import routeName from '../constant';

const routes = [{
    path: 'ph-bank-acc',
    name: routeName.PH_BANK_ACC,
    component: () => import('@/views/aplCatl640and631/B5/landingPage/Index.vue'),
    meta: { auth: true, metaTitle: '要保人指定匯款帳戶', leaveAlert: true, code: 'B5', unableBack: true },
}];

export default routes;
